import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["mobileField"]

  connect() {
    this.toggle()
  }

  toggle() {
    const selectedMethod = this.element.querySelector('input[name$="[access_verification]"]:checked')?.value
    
    if (selectedMethod === "sms") {
      this.mobileFieldTarget.classList.remove("hidden")
      this.mobileFieldTarget.querySelector("input").required = true
    } else {
      this.mobileFieldTarget.classList.add("hidden")
      this.mobileFieldTarget.querySelector("input").required = false
    }
  }
}
